import React, { useState } from "react";

const EditUserProfile = ({
  userInfo,
  setUserInfo,
  handleSave,
  handleEditToggle,
}) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUserInfo((prev) => ({ ...prev, profileImageUrl: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePasswordChange = () => {
    if (newPassword === confirmPassword) {
      setUserInfo((prev) => ({ ...prev, password: newPassword }));
      setNewPassword("");
      setConfirmPassword("");
    } else {
      alert("Passwords do not match!");
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center">
        <label
          htmlFor="name"
          className="block text-sm font-medium text-gray-300 w-32"
        >
          Name:
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={userInfo.name}
          onChange={handleInputChange}
          className="rounded-lg ml-2 mt-1 block shadow-sm text-black font-bold px-2 outline-none"
        />
      </div>
      <div className="flex items-center">
        <label
          htmlFor="email"
          className="block text-sm font-medium text-gray-300 w-32"
        >
          Email:
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={userInfo.email}
          onChange={handleInputChange}
          className="rounded-lg ml-2 mt-1 block shadow-sm text-black font-bold px-2 outline-none"
        />
      </div>
      <div className="flex items-center">
        <label
          htmlFor="department"
          className="block text-sm font-medium text-gray-300 w-32"
        >
          Department:
        </label>
        <input
          type="text"
          id="department"
          name="department"
          value={userInfo.department}
          onChange={handleInputChange}
          readOnly
          className="rounded-lg ml-2 mt-1 block shadow-sm text-black font-bold px-2 outline-none"
        />
      </div>
      <div className="flex items-center">
        <label
          htmlFor="profileImage"
          className="block text-sm font-medium text-gray-300 w-32"
        >
          Profile Image:
        </label>
        <input
          type="file"
          id="profileImage"
          name="profileImage"
          accept="image/*"
          onChange={handleImageUpload}
          className="ml-2 mt-1 block text-sm text-gray-300"
        />
      </div>
      {userInfo.profileImageUrl && (
        <div className="flex items-center">
          <span className="block text-sm font-medium text-gray-300 w-32">
            Preview:
          </span>
          <img
            src={userInfo.profileImageUrl}
            alt="Profile"
            className="w-20 h-20 object-cover rounded-full ml-2"
          />
        </div>
      )}
      <div className="flex items-center">
        <label
          htmlFor="newPassword"
          className="block text-sm font-medium text-gray-300 w-32"
        >
          New Password:
        </label>
        <input
          type="password"
          id="newPassword"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="rounded-lg ml-2 mt-1 block shadow-sm text-black font-bold px-2 outline-none"
        />
      </div>
      <div className="flex items-center">
        <label
          htmlFor="confirmPassword"
          className="block text-sm font-medium text-gray-300 w-32"
        >
          Confirm Password:
        </label>
        <input
          type="password"
          id="confirmPassword"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="rounded-lg ml-2 mt-1 block shadow-sm text-black font-bold px-2 outline-none"
        />
      </div>
      <div className="flex items-center">
        <button
          onClick={handlePasswordChange}
          className="ml-32 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          Change Password
        </button>
      </div>
      <div className="flex items-center">
        <label className="block text-sm font-medium text-gray-300 w-32">
          Club (read-only):
        </label>
        <input
          type="text"
          name="club"
          value={userInfo.club}
          readOnly
          className="rounded-lg ml-2 mt-1 block shadow-sm text-black font-bold px-2 outline-none"
        />
      </div>
      <div className="flex items-center">
        <label className="block text-sm font-medium text-gray-300 w-32">
          Role (read-only):
        </label>
        <input
          type="text"
          name="role"
          value={userInfo.role}
          readOnly
          className="rounded-lg ml-2 mt-1 block shadow-sm text-black font-bold px-2 outline-none"
        />
      </div>
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleSave}
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Save
        </button>
        <button
          onClick={handleEditToggle}
          className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditUserProfile;
